module.exports = __webpack_public_path__ + "static/media/white.0641cebb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/white.jpeg
// module id = 2030
// module chunks = 0